"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCMSErrorEvent = exports.default = exports.createErrorEventObject = exports.checkErrorEventObj = exports.THEMES = exports.ERROR_REQUIRED_KEYS = exports.CONTENT = void 0;

var _react = _interopRequireDefault(require("react"));

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon-loader");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.common");

var _Beach = _interopRequireDefault(require("./Themes/Beach/Beach"));

var _NotFound = _interopRequireDefault(require("./Content/NotFound"));

var _Error = _interopRequireDefault(require("./Content/Error"));

var _Alert = _interopRequireDefault(require("./Content/Alert"));

require("./Stopper.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const THEMES = {
  BEACH: 'beach',
  EMPTY: 'empty'
};
exports.THEMES = THEMES;
const CONTENT = {
  NOT_FOUND: 'NotFound',
  ERROR: 'FatalError',
  ERROR_ALERT: 'ErrorAlert',
  INFO_ALERT: 'InfoAlert'
};
exports.CONTENT = CONTENT;
const ERROR_REQUIRED_KEYS = ['eventType', 'errorDetail', 'errorOrigin'];
/**
 * Crea el objeto con la estructura adecuada para un evento de componente de métricas
 * @param {String} eventType
 * @param {String} eventType
 * @param {String} errorDetail
 * @param {String} errorOrigin
 */

exports.ERROR_REQUIRED_KEYS = ERROR_REQUIRED_KEYS;

const createErrorEventObject = inputObj => {
  const finalRes = _objectSpread({
    event: 'cms-error'
  }, inputObj);

  const normalizedStructure = (0, _gerenciatdUtils3.applyTransform2Object)([{
    type: 'string',
    method: str => (0, _gerenciatdUtils3.normalizeString)((0, _gerenciatdUtils3.toKebabCase)(str))
  }], keyName => (0, _gerenciatdUtils3.toKebabCase)(keyName), finalRes);
  return normalizedStructure;
};

exports.createErrorEventObject = createErrorEventObject;

const checkErrorEventObj = taggingInfo => {
  let res = true;
  ERROR_REQUIRED_KEYS.forEach(key => {
    if (typeof taggingInfo[key] === 'undefined') {
      res = false;
    }
  });
  return res;
};

exports.checkErrorEventObj = checkErrorEventObj;

const sendCMSErrorEvent = inputObj => {
  const checkObj = checkErrorEventObj(inputObj);
  const object = createErrorEventObject(inputObj);

  try {
    if (checkObj) {
      window.nookInfoExchange.sendMessage('Metrics', object);
    } else {
      (0, _gerenciatdUtils2.errorLog)('TaggingInfo is no properly defined', '[checkEventObj] no right event structure');
    }
  } catch (err) {// TODO monirorizar donde toque.
  }
};

exports.sendCMSErrorEvent = sendCMSErrorEvent;

const themeLoader = theme => {
  switch (theme) {
    case THEMES.EMPTY:
      return null;

    case THEMES.BEACH:
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Beach.default, {});
  }
};

const getInPageErrorDetails = contentProps => {
  const {
    errorName,
    errorCode,
    errorDetails
  } = contentProps;
  let errorDetail = `${errorName}`;

  if (errorCode) {
    errorDetail = `${errorDetail}-${errorCode}`;
  }

  if (errorDetails) {
    errorDetail = `${errorDetail}-${errorDetails}`;
  }

  return errorDetail;
};

const createSondaContext = contextData => {
  if (contextData) return contextData;else {
    let clientIDs = null;

    if (window.IC && window.IC.getClientIds) {
      clientIDs = window.IC.getClientIds();
    }

    const context = {
      pageSegment: 'particulares' || '',
      contextURL: window.location.href || '',
      clientIDs
    };
    return context;
  }
};

const createFrontSonda = (context, projectId) => {
  const frontSonda = new _gerenciatdUtils.default({
    processName: `error-page;stopper;${projectId}`,
    context: createSondaContext(context),
    filePath: 'unified/stopper/index'
  });
  return frontSonda;
};

const contentLoader = (content, contentProps, projectId, taggingInfo, contextData) => {
  let contentToLoad = null;
  let errorDetail = '';

  const finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
    componentVariation: taggingInfo.componentVariation || 'all',
    componentProduct: taggingInfo.componentProduct || '',
    componentName: taggingInfo.componentName || `Stopper;${content}`
  });

  switch (content) {
    case CONTENT.ERROR:
      contentToLoad = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.default, {
        taggingInfo: finalTaggingInfo
      });
      errorDetail = 'FatalError-500-ErrorJs';
      break;

    case CONTENT.ERROR_ALERT:
      {
        contentToLoad = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
          iconColor: _gerenciatdUnifiedicons.COLOR.PIPPER,
          iconId: _gerenciatdUnifiedicons.ICONS_ID.Alerta,
          errorToPrint: contentProps,
          taggingInfo: finalTaggingInfo
        });
        errorDetail = getInPageErrorDetails(contentProps);
        break;
      }

    case CONTENT.INFO_ALERT:
      contentToLoad = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
        iconColor: _gerenciatdUnifiedicons.COLOR.BLUE,
        iconId: _gerenciatdUnifiedicons.ICONS_ID.Informacion,
        errorToPrint: contentProps,
        taggingInfo: finalTaggingInfo
      });
      errorDetail = getInPageErrorDetails(contentProps);
      break;

    default:
      contentToLoad = /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotFound.default, {
        taggingInfo: finalTaggingInfo
      });
      errorDetail = 'NotFound-404';
      break;
  }

  sendCMSErrorEvent({
    eventType: 'error-page',
    errorDetail,
    errorOrigin: projectId
  });
  const frontSonda = createFrontSonda(contextData, projectId);
  frontSonda.errorMessage({
    errorDetail,
    info: `error-page, projectId: ${projectId}, info: ${errorDetail}`
  });
  return contentToLoad;
};
/* iF CHILDREN IS DEFINED WE IGNORE CONTENT */


const Stopper = ({
  children,
  theme,
  content,
  contentProps,
  projectId,
  taggingInfo,
  contextData
}) => {
  const finalContent = children ? null : content;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `Stopper ${content} ${theme}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "childrenContainer",
      children: [children && children, !children && finalContent && contentLoader(finalContent, contentProps, projectId, taggingInfo, contextData)]
    }), themeLoader(theme)]
  });
};

Stopper.propTypes = {
  /**
   * {
   *  "info": "Establece los elementos que forman el componente",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  children: _propTypes.default.node,

  /**
   * {
   *  "info": "Establece el contenido del componente",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  content: _propTypes.default.oneOf(Object.values(CONTENT)),

  /**
   * {
   *  "info": "Define el tema del componente en el array THEMES",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  theme: _propTypes.default.oneOf(Object.values(THEMES)),

  /**
   * {
   *  "info": "Define el nombre del proyecto desde el que se pinta la página de error",
   *  "kind": "both",
   *  "beautifulName": "Nombre del proyecto"
   * }
   */
  projectId: _propTypes.default.string,

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object,

  /**
   * {
   *  "info": "Props passed to content, used to customize the information that is showed",
   *  "kind": "both",
   *  "beautifulName": "Propiedades contenido"
   * }
   */
  contentProps: _propTypes.default.shape({
    button: _propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }),
    title: _propTypes.default.string,
    msg: _propTypes.default.arrayOf(_propTypes.default.string),
    phone: _propTypes.default.string,
    errorName: _propTypes.default.string,
    errorCode: _propTypes.default.string,
    errorDetails: _propTypes.default.string
  }),

  /**
   * {
   *  "info": "Context info necessary for frontSonda",
   *  "kind": "both",
   *  "beautifulName": "contexto"
   * }
   */
  contextData: _propTypes.default.object
};
Stopper.defaultProps = {
  children: null,
  theme: THEMES.BEACH,
  content: CONTENT.NOT_FOUND,
  projectId: 'unknown',
  taggingInfo: {},
  contentProps: {},
  contextData: null
};
var _default = Stopper;
exports.default = _default;

//# sourceMappingURL=index.js.map